import { ADVISORS_MATCH_BASE_URL } from '@ria-client/utils/advisorMatch/urls';

export { ADVISORS_MATCH_BASE_URL };

export type AdvisorMatchUrlInput = {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmContent?: string;
  anonymousId?: string;
};

export function buildAdvisorMatchUrl(input: AdvisorMatchUrlInput = {}): string {
  const url = new URL(ADVISORS_MATCH_BASE_URL);
  const { utmSource, utmMedium, utmCampaign, utmContent, anonymousId } = input;
  if (utmSource) url.searchParams.set('utm_source', utmSource);
  if (utmMedium) url.searchParams.set('utm_medium', utmMedium);
  if (utmCampaign) url.searchParams.set('utm_campaign', utmCampaign);
  if (utmContent) url.searchParams.set('utm_content', utmContent);
  if (anonymousId) url.searchParams.set('anonymous_id', anonymousId);
  return url.toString();
}
